import React, { useContext, useEffect, useRef, useState } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import {
  faSearch,
  faMapMarkerAlt,
  faRobot,
  faChartBar,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import HacemosUI from '../ui/Hacemos_UI';

function Hacemos() {
  const { language, translations } = useContext(LanguageContext);
  const currentTranslations = translations[language];
  const [visibleItems, setVisibleItems] = useState([]);
  const itemRefs = useRef([]);

  const icons = [faSearch, faMapMarkerAlt, faRobot, faChartBar, faUsers];
  const colors = [
    'from-green-500 to-teal-600',
    'from-blue-500 to-cyan-600',
    'from-purple-500 to-indigo-600',
    'from-orange-500 to-red-600',
    'from-pink-500 to-rose-600',
  ];

  const testimoniosData = [
    {
      id: 1,
      title: translations[language].testimonios.title1,
      content: translations[language].testimonios.content1,
      image: "/we_does/cultivo_1.png",
    },
    {
      id: 2,
      title: translations[language].testimonios.title2,
      content: translations[language].testimonios.content2,
      image: "/we_does/cultivo_2.png",
    },
    {
      id: 3,
      title: translations[language].testimonios.title3,
      content: translations[language].testimonios.content3,
      image: "/images/scan.jpg",
    },
    {
      id: 4,
      title: translations[language].testimonios.title4,
      content: translations[language].testimonios.content4,
      image: "/we_does/cultivo_5.png",
    },
    {
      id: 5,
      title: translations[language].testimonios.title5,
      content: translations[language].testimonios.content5,
      image: "/images/principal2.png",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.getAttribute('data-index') || '0');
            setVisibleItems((prev) => [...prev, index]);
          }
        });
      },
      { threshold: 0.3 }
    );

    itemRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <HacemosUI
      currentTranslations={currentTranslations}
      testimoniosData={testimoniosData}
      icons={icons}
      colors={colors}
      visibleItems={visibleItems}
      itemRefs={itemRefs}
    />
  );
}

export default Hacemos;